//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: "educationinfo",
  components: {
  },
  props: {
    //业务数据
    record: { type: Object, default: () => ({}) },
    //流程数据
    process: { type: Object, default: () => ({}) },
    //规则绑定
    rules: { type: Object, default: () => ({}) },
    //自定义的参数
    config: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      currently:[{ //当前是否已注册测试数据
        propertyValue:"1",
        propertyLabel:""
      }],
      //外网下拉框获取选项
      apiUrl: "onboarding/getSelectOption",
      edubackgrounpList:[]
    };
  },
  methods: {
      initSelect(){
        let p_edubackgrounp = {
            showcode:'edubackgrounpList',
            selectcode:'SYS_CDFCODECONFIG',
            hasnull:false,
            paras:{"paras0":"EDUBACKGROUNP","paras1":"1"}
        };
        let params = [];
        params.push(p_edubackgrounp);
        this.initDropDownWithUrl(this,params,this.apiUrl);
   
  },
  
},
created() {
  this.initSelect();
}
}



// WEBPACK FOOTER //
// ./src/pcpage/hr/recruitment/resumeApply/educationinfo.vue